import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";

import type { AppDispatch } from "./index";
import type { RootState } from "./types";
import { useMemo } from "react";

export const useDispatchRoot: () => AppDispatch = useDispatch;
export const useSelectorRoot: TypedUseSelectorHook<RootState> = useSelector;
export function useSelectorMemo<T>(fn: (store: RootState) => T): T {
  const memoFunc = useMemo(() => fn, [fn]);
  return useSelector(memoFunc);
}
